import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import {
  DataContextBuilder,
  ElderDataToolbarComponent,
  ElderTableComponent,
  ElderTableToolbarDirective,
  ElderToastService,
  IDataContext,
} from '@elderbyte/ngx-starter'
import { JsspSettings } from '../jssp-settings'
import { JsspSettingsService } from '../jssp-settings.service'
import { Router } from '@angular/router'
import { catchError, tap } from 'rxjs/operators'
import { EMPTY } from 'rxjs'
import { JsspSettingsAction } from '../jssp-settings.command'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
} from '@angular/material/table'
import { MatIcon } from '@angular/material/icon'
import { MatMenuItem } from '@angular/material/menu'

@Component({
  selector: 'app-jssp-settings-browser',
  templateUrl: './jssp-settings-browser.component.html',
  styleUrls: ['./jssp-settings-browser.component.scss'],
  imports: [
    ElderTableComponent,
    ElderTableToolbarDirective,
    ElderDataToolbarComponent,
    MatMenuItem,
    MatIcon,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    ElderTranslatePipe,
  ],
})
export class JsspSettingsBrowserComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly data: IDataContext<JsspSettings>
  private settingsService = inject(JsspSettingsService)
  private elderToastService = inject(ElderToastService)
  private router = inject(Router)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.data = DataContextBuilder.start<JsspSettings>()
      .pageSize(20)
      .reloadOnLocalChanges()
      .autoStartAsap()
      .build(this.settingsService)
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  open($event: JsspSettings) {
    this.router.navigate([{ outlets: { side: ['jssp-settings', $event.id] } }])
  }

  onCreate() {
    this.router.navigate([{ outlets: { side: ['jssp-settings', 'new'] } }])
  }

  onRemove(jsspSettings: JsspSettings[]) {
    this.settingsService
      .deleteAll(jsspSettings)
      .pipe(tap(() => this.elderToastService.info('messages.deleting_successful')))
      .pipe(
        catchError((error) => {
          this.elderToastService.error('messages.deleting_failed', error)
          return EMPTY
        })
      )
      .subscribe()
  }

  createGlobal() {
    this.settingsService
      .sendCommand({ action: JsspSettingsAction.CREATE_GLOBAL })
      .pipe(
        tap(() => {
          this.elderToastService.info('messages.action_successful')
          this.data.reload()
        })
      )
      .pipe(
        catchError((error) => {
          this.elderToastService.error('messages.action_failed', error)
          return EMPTY
        })
      )
      .subscribe()
  }
}
